<template>
    <transition name="fade2">
        <div class="loader-overlay pin fixed bg-white flex content-center justify-center z-50">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="50px" height="50px" viewBox="0 0 50 50" class="loader-spinner self-center">
                <path fill="#2980b9" d="M7.157,25c0-9.839,8.004-17.843,17.843-17.843S42.843,15.161,42.843,25c0,6.103-3.082,11.495-7.77,14.714 l4.991,3.633C45.363,38.988,48.75,32.382,48.75,25C48.75,11.904,38.097,1.25,25,1.25C11.905,1.25,1.25,11.904,1.25,25 S11.905,48.749,25,48.749v-5.906C15.161,42.843,7.157,34.838,7.157,25z"/>
            </svg>
        </div>
    </transition>
</template>

<script>
    export default {
        props: [
            'message'
        ],
        data: function () {
            return {
                //
            }
        },
        mounted() {
            if (this.$root.debug) console.log('Loader mounted.')
        },
        methods: {
            //
        }
    }
</script>

<style lang="less">
    .fade-enter-active, .fade-leave-active {
        opacity: 1;
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0
    }
    .loader-overlay {
        background: rgba(255, 255, 255, 0.5);
        z-index: 99;

        .loader-spinner {
            animation-name: spin;
            animation-duration: 1s;
            animation-iteration-count: infinite;
            animation-timing-function: linear;
        }
    }

    @keyframes spin {
        from {transform:rotate(0deg);}
        to {transform:rotate(360deg);}
    }
</style>
